import styled, { css } from 'styled-components';
import { colors } from '@/globalStyles';
import store from '@/store';
import { SMARTPHONE } from '@/constants';

export const ModalWrapperStyled = styled.div`
  width: 600px;
  outline: none;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: ${colors.white};
  border-radius: 10px;
  box-shadow: 2px 4px 16px 0 rgba(0, 0, 0, 0.25);

  ${props => {
    const { core: { targetDevice } } = store.getState();

    switch (targetDevice) {
      case SMARTPHONE: {
        return css``;
      }
      default: {
        return null;
      }
    }
  }}
`;

export const RowStyled = styled.div`
  display: grid;
  grid-template-columns: 1fr max-content;
  gap: 10px;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${colors.whiteSmoke};
  padding: 0px 0px 7px;
  margin: 0px 30px 15px 0px;
  :last-child {
    margin-bottom: 0px;
  }
`;
